/**
 * @author michalstolarski
 * @since 2023-2-23
 */

import * as React from "react";
import styled from "styled-components";

import { ROUTES } from "@config/app.routing";

import { AVAILABLE_LANGS } from "@typings/globals";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { Markdown } from "@containers/Markdown";

import { TranslateFunction } from "@hooks/useTranslate";

interface Props {
  testId?: string;
  className?: string;
  language: AVAILABLE_LANGS;
  translate: TranslateFunction;
}

const TermsOfUseInfo = (props: Props) => {
  const termsOfUseLink = `/${props.language}${ROUTES.TERMS_OF_USE}`;
  const privacyPolicyLink = `/${props.language}${ROUTES.PRIVACY_POLICY}`;

  return (
    <TestWrapper testId={props.testId}>
      <TermsWrapper className={props.className}>
        <Markdown>
          {props.translate(
            "batmaid_pwa_booking.continuing_agree_terms_and_privacy",
            {
              termsOfUseLink,
              privacyPolicyLink,
            },
          )}
        </Markdown>
      </TermsWrapper>
    </TestWrapper>
  );
};

export { TermsOfUseInfo };

const TermsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.margins.base_x4};
  font-size: ${({ theme }) => theme.fonts.sizes.body2};
  color: ${({ theme }) => theme.palette.grey600};
`;
